import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";

// Layout
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Pages
import HomePage from "./components/pages/HomePage";
import AboutPage from "./components/pages/AboutPage";
import PrestressedConcretePage from "./components/pages/PrestressedConcretePage";
import ProductsPage from "./components/pages/ProductsPage";
import EngineeringPage from "./components/pages/EngineeringPage";
import ComparisonPage from "./components/pages/ComparisonPage";
import QualityPage from "./components/pages/QualityPage";
import ArticlesPage from "./components/pages/ArticlesPage";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/prestressed-concrete" element={<PrestressedConcretePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/engineering" element={<EngineeringPage />} />
              <Route path="/comparison" element={<ComparisonPage />} />
              <Route path="/quality" element={<QualityPage />} />
              <Route path="/articles" element={<ArticlesPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
